import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  ButtonGroup,
} from "reactstrap";
import Modal from "@material-ui/core/Modal";
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import moment from "moment";
import { useModalAlert } from "../../../GeneralComponents";

const EventLabels = ({ reload }) => {
  const [openModal, setOpenModal] = useState(false);
  const [fechaInicio, setFechaInicio] = useState(null);
  const [fechaFin, setFechaFin] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDesciption] = useState("");
  const [priority, setPriority] = useState("");
  const [errors, setErrors] = useState({});
  const { showModalAlert } = useModalAlert();


  const validateData = () => {
    let errors = {};

    if (!fechaInicio) errors.fechaInicio = "Ingrese una Fecha de Inicio";
    if (!fechaFin) errors.fechaFin = "Ingrese una Fecha de Fin";
    if (title.trim() === "") errors.title = "Ingrese el Titulo del Evento";
    if (priority === "") errors.priority = "Ingrese la Prioridad del Evento";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const saveEvent = async () => {
    if (validateData()) {
      const user = JSON.parse(sessionStorage.getItem("usuario"));
      const dataSend = {
        id_usuario: user.id_usuario,
        titulo: title,
        descripcion: description,
        fecha_inicio: moment(fechaInicio).format("YYYY-MM-DD HH:mm:ss"),
        fecha_final: moment(fechaFin).format("YYYY-MM-DD HH:mm:ss"),
        prioridad: priority,
        estado: 2,
      };

      try {
        const response = await fetch(
          process.env.REACT_APP_PUBLIC_URL + "calendario/create",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify(dataSend),
          },
        );
        const data = await response.json();
        if (response.ok) {
          showModalAlert("success", "Evento creado correctamente");
          setOpenModal(false);
          setTitle("");
          setDesciption("");
          setFechaInicio(null);
          setFechaFin(null);
          setPriority("");
          // 3. LLAMADA CRUCIAL: Esto dispara getCalendarData en el padre
          reload();
        }
      } catch (error) {
        console.log("Error..:", error);
        showModalAlert("danger", "Error al crear el evento");
      }
    }
  };

  return (
    <Col md={12} lg={12} xl={3}>
      <Card className="card--not-full-height">
        <CardBody>
          <div className="card__title">
            <h5 className="bold-text">Prioridad Eventos</h5>
          </div>
          <p className="typography-message">
            <span className="calendar-label calendar-label--red" /> Prioridad
            Alta
          </p>
          <p className="typography-message">
            <span className="calendar-label calendar-label--green" /> Prioridad
            Media
          </p>
          <p className="typography-message">
            <span className="calendar-label calendar-label--blue" /> Prioridad
            Baja
          </p>
          <ButtonToolbar>
            <ButtonGroup className="btn-group--justified">
              <Button
                color="primary"
                onClick={() => {
                  setOpenModal(true);
                }}
              >
                Crear un Evento
              </Button>
            </ButtonGroup>
          </ButtonToolbar>
        </CardBody>
      </Card>
      <Modal
        open={openModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "120%", margin: 10 }}
        >
          <div className="card__title">
            <h4 className="bold-text">Agregar Evento </h4>
          </div>
          <form className="material-form">
            <div>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DateTimePicker
                  label="Fecha de Inicio"
                  views={["year", "month", "date"]}
                  style={{ width: 250 }}
                  value={fechaInicio}
                  onChange={(date) => {
                    setFechaInicio(date.toDate());
                  }}
                  animateYearScrolling
                  format="YYYY/MM/DD HH:mm:ss"
                  error={
                    errors.hasOwnProperty("fechaInicio")
                      ? errors.fechaInicio !== ""
                      : false
                  }
                  helperText={errors.fechaInicio}
                />
              </MuiPickersUtilsProvider>
              <MuiPickersUtilsProvider utils={MomentUtils}>
                <DateTimePicker
                  label="Fecha de Fin"
                  views={["year", "month", "date"]}
                  style={{ width: 250, marginLeft: 40 }}
                  value={fechaFin}
                  onChange={(date) => {
                    setFechaFin(date.toDate());
                  }}
                  animateYearScrolling
                  format="YYYY/MM/DD HH:mm:ss"
                  error={
                    errors.hasOwnProperty("fechaFin")
                      ? errors.fechaFin !== ""
                      : false
                  }
                  helperText={errors.fechaFin}
                />
              </MuiPickersUtilsProvider>
            </div>
            <div style={{ marginTop: 40 }}>
              <TextField
                required
                id="title-standard-required"
                label="Titulo"
                type="text"
                className="material-form__field"
                style={{ width: 250 }}
                //value={this.state.address}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
                error={
                  errors.hasOwnProperty("title") ? errors.title !== "" : false
                }
                helperText={errors.title}
              />
              <TextField
                className="material-form__field"
                label="Prioridad"
                id="priority-select"
                style={{ width: 250, marginLeft: 40 }}
                select
                onChange={(event) => {
                  setPriority(event.target.value);
                }}
                error={
                  errors.hasOwnProperty("priority")
                    ? errors.priority !== ""
                    : false
                }
                helperText={errors.priority}
              >
                <MenuItem className="material-form__option" key={1} value={"3"}>
                  Alta
                </MenuItem>
                <MenuItem className="material-form__option" key={2} value={"2"}>
                  Media
                </MenuItem>
                <MenuItem className="material-form__option" key={3} value={"1"}>
                  Baja
                </MenuItem>
              </TextField>
            </div>
            <div className="form" style={{ marginTop: 40 }}>
              <span className="form__form-group-label">Descripción</span>
              <textarea
                name="descripton"
                onChange={(e) => {
                  setDesciption(e.target.value);
                }}
              ></textarea>
            </div>
          </form>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 20,
            }}
          >
            <Button
              variant="contained"
              onClick={() => {
                setOpenModal(false);
              }}
            >
              Cerrar
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                saveEvent();
              }}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Modal>
    </Col>
  );
};

export default EventLabels;
